import { single3ds7xj9roxi5z as single } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SmsProofComponent36prs3ejmwele as SmsProofComponent } from './SmsProofComponent.mjs';
import { EmailProofComponentfolcv3lujl12 as EmailProofComponent } from './EmailProofComponent.mjs';
import { PasswordProofComponent3726lda9sds27 as PasswordProofComponent } from './PasswordProofComponent.mjs';
import { TotpProofComponento88lcxb112zs as TotpProofComponent } from './TotpProofComponent.mjs';
import { BackupCodeProofComponentdg3wgu2jhew9 as BackupCodeProofComponent } from './BackupCodeProofComponent.mjs';
import { WebAuthNProofComponent1mqorb4klgfjg as WebAuthNProofComponent } from './WebAuthNProofComponent.mjs';
import { listOfNotNull2woi2boe01ub4 as listOfNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function components(_this__u8e3s4, subjectType) {
  subjectType = subjectType === VOID ? single(_this__u8e3s4.subjects_1.get_keys_wop4xp_k$()) : subjectType;
  var tmp0_safe_receiver = _this__u8e3s4.smsProof_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new (SmsProofComponent())(tmp0_safe_receiver);
  }
  var tmp_0 = tmp;
  var tmp1_safe_receiver = _this__u8e3s4.emailProof_1;
  var tmp_1;
  if (tmp1_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = new (EmailProofComponent())(tmp1_safe_receiver);
  }
  var tmp_2 = tmp_1;
  var tmp2_safe_receiver = _this__u8e3s4.passwordProof_1;
  var tmp_3;
  if (tmp2_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_3 = new (PasswordProofComponent())(tmp2_safe_receiver, subjectType);
  }
  var tmp_4 = tmp_3;
  var tmp3_safe_receiver = _this__u8e3s4.oneTimePasswordProof_1;
  var tmp_5;
  if (tmp3_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_5 = new (TotpProofComponent())(tmp3_safe_receiver, subjectType);
  }
  var tmp_6 = tmp_5;
  var tmp4_safe_receiver = _this__u8e3s4.backupCodeProof_1;
  var tmp_7;
  if (tmp4_safe_receiver == null) {
    tmp_7 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_7 = new (BackupCodeProofComponent())(tmp4_safe_receiver, subjectType);
  }
  var tmp_8 = tmp_7;
  var tmp5_safe_receiver = _this__u8e3s4.webAuthNProof_1;
  var tmp_9;
  if (tmp5_safe_receiver == null) {
    tmp_9 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_9 = new (WebAuthNProofComponent())(tmp5_safe_receiver, subjectType, _this__u8e3s4.webAuthNIncludePasskeyUI_1);
  }
  return listOfNotNull([tmp_0, tmp_2, tmp_4, tmp_6, tmp_8, tmp_9]);
}
//region block: exports
export {
  components as components1lybon96zje1u,
};
//endregion

//# sourceMappingURL=getComponents.mjs.map
